/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
// var root = window.location.href.indexOf("pc.hipc.cn") != -1 ? "https://api.hipcapi.com" : "https://api2.hipcapi.com"; //接口域名
var root = window.location.href.includes("pc.hipc.cn") ? "https://api.hipcapi.com" : "https://api-beta.hipcapi.com"; //接口域名
var login = 'https://kjktestapi.hipcapi.com'
import axios from 'axios';
import store from 'vuex';
//默认超时时间
axios.defaults.timeout = 30000;
//返回其他状态码
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500;
};
//跨域请求，允许保存cookie
// axios.defaults.withCredentials = true;
// NProgress 配置
// NProgress.configure({
//   showSpinner: false
// });
//http request拦截
axios.interceptors.request.use(config => {
  //开启 progress bar
  // NProgress.start();
  const meta = (config.meta || {});
  // const isToken = meta.isToken === false;
  if (config.url.indexOf('miui') == 0){
    config.headers['Content-Type'] = `application/x-www-form-urlencoded`;
    let token = localStorage.getItem('token')//获取本地存储的token
    if (token){
      config.headers['token'] = token;
    }
    config.url = login + config.url.replace('miui','')
    return config;
  }
  if (window.location.href.includes('/FileTransfer')) { // 文件上传H5
    let data_opt = JSON.parse(localStorage.getItem('data_opt'))
    config.headers['token'] = data_opt.token
    config.headers['user-id'] = data_opt['user-id']
    config.headers['app'] = data_opt.app
    config.headers['platform'] = data_opt.platform
    config.url = data_opt.patter === 'Release' ? "https://api.hipcapi.com" + config.url : "https://api-beta.hipcapi.com" + config.url //接口域名
  } else if (window.location.href.includes("/pc/")) { // 分享电脑信息
    config.url = window.location.href.includes("_R") ? "https://api.hipcapi.com" + config.url : "https://api-beta.hipcapi.com" + config.url
  } else if (window.location.href.includes("/s/")) { // 分享文件
    config.url = window.location.href.includes("_R") ? "https://api.hipcapi.com" + config.url : "https://api-beta.hipcapi.com" + config.url
  } else if (window.location.href.includes("/ShareFilesDetail/")) { // 旧版分享文件
    config.url = window.location.href.includes("/R") ? "https://api.hipcapi.com" + config.url : "https://api-beta.hipcapi.com" + config.url
  } else if (window.location.href.includes("/Statistics")) { // iwin11交易统计通知
    config.url = "https://pay.iwin11.cn" + config.url
  } else { // 默认
    config.url = root + config.url
  }
  // if (getToken() && !isToken) {
  //   //让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
  //   config.headers['Asit-Auth'] = 'bearer ' + getToken()
  // }
  //headers中配置serialize为true开启序列化
  // if (config.method === 'post' && meta.isSerialize === true) {
  //   config.data = serialize(config.data);
  // }
  return config
}, error => {
  return Promise.reject(error)
});
//http response 拦截
axios.interceptors.response.use(res => {
  //关闭 progress bar
  // NProgress.done();
  //获取状态码
  const status = res.data.code || res.status;
  // const statusWhiteList = website.statusWhiteList || [];
  const message = res.data.msg || res.data.error_description || '未知错误';
  //如果在白名单里则自行catch逻辑处理
  // if (statusWhiteList.includes(status)) return Promise.reject(res);
  // //如果是401则跳转到登录页面
  if (status === 401) {

  };
  // 如果请求为非200否者默认统一处理
  if (status !== 200) {
    // Message({
    //   message: message,
    //   type: 'error'
    // });
    // return Promise.reject(new Error(message))
  }
  return res.data;
}, error => {
  // NProgress.done();
  return Promise.reject(new Error(error));
});

axios.jsonp = (url,data)=>{
  if(!url)
    throw new Error('url is necessary')
  const callback = 'callback'
  const JSONP = document.createElement('script')
  JSONP.setAttribute('type','text/javascript')

  const headEle = document.getElementsByTagName('head')[0]

  let ret = '';
  if(data){
    if(typeof data === 'string')
      ret = '&' + data;
    else if(typeof data === 'object') {
      for(let key in data)
        ret += '&' + key + '=' + encodeURIComponent(data[key]);
    }
    ret += '&_time=' + Date.now();
  }
  JSONP.src = `${url}?callback=${callback}${ret}`;
  return new Promise( (resolve,reject) => {
    window[callback] = r => {
      resolve(r)
      headEle.removeChild(JSONP)
      delete window[callback]
    }
    headEle.appendChild(JSONP)
  })

}

export default axios;



// WEBPACK FOOTER //
// ./src/router/axios.js